module.exports = __webpack_public_path__ + "media/images/blobberstova-d0b209b943e631f35af5b78288d1c608.jp2";